import Choices from "choices.js"
import "choices.js/public/assets/styles/choices.min.css"
import { getFormfieldIcon } from "../utils/utils"

class Dropdown {
  constructor() {
    document.querySelectorAll("select").forEach(element => {
      const isMultiple = element.getAttribute("multiple")
      const renderSelected = element.getAttribute("data-render-selected") || "auto"
      const searchEnabled = element.getAttribute("data-search-enabled") || element.options.length > 20
      const extraClass = element.getAttribute("data-dropdown-class")

      // eslint-disable-next-line no-undef
      const choices = new Choices(element, {
        searchEnabled: searchEnabled,
        searchPlaceholderValue: element.getAttribute("search-placeholder"),
        placeholderValue: element.getAttribute("placeholder"),
        itemSelectText: "",
        removeItemButton: isMultiple,
        renderSelectedChoices: renderSelected,
        shouldSort: false,
        shouldSortItems: false,
        position: "bottom",
        callbackOnInit: function() {
          if (extraClass) {
            this.containerOuter.element.classList.add(extraClass)
          }
        },
      })

      element.clearInput = () => {
        choices.unhighlightAll()
      }

      if (element.getAttribute("js-choices-instance")) {
        window.choices = window.choices || {}
        window.choices[element.getAttribute("js-choices-instance")] = choices
      }

      if (element.classList.contains("holder-required")) {
        choices.containerInner.element.classList.add("error")
        element.addEventListener("addItem", () => {
          choices.containerInner.element.classList.remove("error")
          const messageEl = choices.containerInner.element.closest(".field").querySelector(".message")
          if (messageEl) {
            messageEl.remove()
          }
        })
      }

      // custom handling of placeholder for multiple option dropdown
      if (isMultiple) {
        const togglePlaceholder = () =>
          (choices.containerInner.element.querySelector("input.choices__input--cloned").style.display = choices
            .passedElement.value
            ? "none"
            : "")

        element.addEventListener("addItem", togglePlaceholder)
        element.addEventListener("removeItem", togglePlaceholder)
      }

      const icon = getFormfieldIcon(element)

      if (icon) {
        choices.containerInner.element.classList.add("with-icon")
        choices.containerInner.element.appendChild(icon)
      }
    })
  }
}

export default Dropdown
